import React, { Component } from "react";
import {
  BrowserRouter,
  Router,
  Route,
  Switch,
  HashRouter,
  Redirect
} from "react-router-dom";
import { createBrowserHistory } from "history";
import Dashboard from "../containers/DashboardContainer";
import Login from "../containers/LoginContainer";
import OTP from "../containers/OTPContainer";
import VerifyOTP from "../containers/VerifyOTPContainer";
import UpdateProfileContainer from "../containers/UpdateProfileContainer";
import PromptMsgContainer from "../containers/PromptMsgContainer";
import DefaultLayout from "../containers/DefaultLayout";
import Category from "../containers/CategoryContainer";

import ForgotPassword from "../containers/ForgotpasswordContainer";

import SignUp from "../containers/SignUpContainer";

import Feedback from "../containers/FeedbackContainer";

import MyProfile from "../containers/MyProfileContainer";
import ResetPwd from "../containers/ResetPwdContainer";
import EditProfile from "../containers/EditProfileContainer";
import Orders from "../containers/OrdersContainer";
import NormalOrders from "../containers/NormalOrdersContainer";
import CreditNotesContainer from "../containers/CreditNotesContainer";
import PaymentsContainer from "../containers/PaymentsContainer";
import SupportContainer from "../containers/SupportContainer";
import PurchaseReturns from "../containers/PurchaseReturnsContainer";
import ExpiryReturns from "../containers/ExpiryReturnsContainer"
import InvoiceContainer from "../containers/InvoiceContainer";
import NotificationContainer from "../containers/NotificationContainer";

// import OrderView from "../screens/OrderView";
var history = createBrowserHistory();

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem("userdata") ? (
        <Component {...props} />
      ) : (
        <Redirect to="/login" />
      )
    }
  />
);

function AppNavigator() {
  return (
    <Switch>
      <Route path="/signup" name="SignUp" component={SignUp} />,
      <Route path="/login" name="Login" component={Login} />,
      <Route
        path="/forgotpassword"
        name="ForgotPassword"
        component={ForgotPassword}
      />
      ,
      <Route path="/otp" name="OTP" component={OTP} />,
      <Route path="/verifyotp" name="VerifyOTP" component={VerifyOTP} />,
      <Route path="/updateprofile" component={UpdateProfileContainer} />
      ,
      <Route path="/suspendprompt" component={PromptMsgContainer} />
      <Route path="/dashboard" name="Dashboard" component={DefaultLayout} />,
      <Route path="/" name="Dashboard" component={DefaultLayout} />
      ,
      <Route
        path="/dashboard/myprofile"
        name="My Profile"
        component={MyProfile}
      />
      ,
      <Route
        path="/dashboard/resetpassword"
        name="Reset Password"
        component={ResetPwd}
      />
      ,
      <Route
        path="/dashboard/settings/category"
        name="Category"
        component={Category}
      />
      ,
      <Route path="/dashboard/feedback" name="Feedback" component={Feedback} />,
      <Route path="/dashboard/orders" name="Orders" component={Orders} />,
      <Route
        path="/dashboard/normal-orders"
        name="NormalOrders"
        component={NormalOrders}
      />
      ,
      <Route
        path="/dashboard/creditnotes"
        name="Credit Notes"
        component={CreditNotesContainer}
      />
      ,
      <Route
        path="/dashboard/invoices"
        name="Invoices"
        component={InvoiceContainer}
      />
      ,
      <Route
        path="/dashboard/payments"
        name="Payments"
        component={PaymentsContainer}
      />
      ,
      <Route
        path="/dashboard/spport"
        name="Support"
        component={SupportContainer}
      />
      ,
      <Route
        path="/dashboard/salesreturns"
        name="Purchase Returns"
        component={PurchaseReturns}
      />
      ,
      <Route
        path="/dashboard/expiryreturns"
        name="Expiry Returns"
        component={ExpiryReturns}
      />
      ,
      <Route
        path="/dashboard/editprofile"
        name="EditProfile"
        component={EditProfile}
      />
      ,
      <Route
        path="/dashboard/notifications"
        name="Notifications"
        component={NotificationContainer}
      />
      ,
      {/* <Route
        path="/dashboard/orderview"
        name="OrderView"
        component={OrderView}
      />
      , */}
    </Switch>
  );
}
export default AppNavigator;
